import { useState, useEffect } from 'react'
import TextInput from 'components/Inputs/TextInput'

import {
  SubContainer,
  Row,
  FilterColumn,
  ServicesGrid,
  Button,
  SubTitle,
  ButtonText,
  MoneyTextMask
} from '../styles'

export default function ServicesForm ({
  schedule = {},
  services = [],
  onProceed: handleProceed = () => null
}) {
  const { service_category } = schedule
  const [filteredServices, setFilteredServices] = useState ([])
  const [name, setName] = useState ('')

  useEffect (() => {
    filterServices ()
  }, [name])

  const filterServices = () => {
    setFilteredServices (services.filter (service => (
      service.name.toLowerCase ().includes (name.toLowerCase ())
      && service.category.id === service_category.id
    )))
  }

  return (
    <SubContainer>
      <SubTitle>Escolha o serviço</SubTitle>
      <Row style={{marginTop: 10}}>
        <FilterColumn>
          <TextInput
            value={name}
            placeholder='Pesquisar por nome'
            isClearable={true}
            onChange={e => setName (e.target.value)}
            onClear={() => setName ('')}
            inputStyle={{flex: 1, boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
          />
        </FilterColumn>
      </Row>
      <ServicesGrid>
        {filteredServices.map ((service, index) => (
          <Button
            key={index}
            onClick={() => handleProceed ({ service })}
            style={{paddingInline: 15}}
          >
            <ButtonText>{service.name}</ButtonText>
            <MoneyTextMask value={service.price}/>
          </Button>
        ))}
      </ServicesGrid>
    </SubContainer>
  )
}
